function toggleReadMore(btn) {
    var moreContent = btn.nextElementSibling;
    if (moreContent.style.display === "none") {
        moreContent.style.display = "block";
        btn.innerText = "Read Less"; // Change the button text to 'Read Less'
    } else {
        moreContent.style.display = "none";
        btn.innerText = "Read More"; // Change the button text back to 'Read More'
    }
}